const FULL_MOVATIC_ACCESS = 281474976710655;

/** Match ant's is_movatic_admin predicate for membership replacement. */
export function canReplaceMembership(movaticAccess?: number): boolean {
  return movaticAccess === FULL_MOVATIC_ACCESS;
}
